import React from 'react';
import GraphsWidget from '../RedemptionReport/Components/GraphsWidget';
import RollingGraphsWidget from '../RollingRedemptionReport/Components/RollingGraphsWidget';

const GraphsWrapper = function GraphsWrapper({
  userRedemptionData = [],
  branchRedemptionData = [],
  isRolling = false,
  isOperator = false,
  minimumRedemptionCalls = null,
}) {
  return isRolling ? (
    <RollingGraphsWidget
      isOperator={isOperator}
      userRedemptionData={userRedemptionData}
      branchRedemptionData={branchRedemptionData}
      minimumRedemptionCalls={minimumRedemptionCalls}
    />
  ) : (
    <GraphsWidget
      userRedemptionData={userRedemptionData}
      branchRedemptionData={branchRedemptionData}
    />
  );
};

export default GraphsWrapper;
